import { useContext } from 'react';
import { TranslationContext } from './TranslationProvider';
 
// useTranslation hook now uses the global context (UPDATED)
export default function useTranslation() {
  return useContext(TranslationContext); // Use global context for translation
} 